import { environment } from '@gaodun.com/gtools';
import Http from '@/utils/http';
import { ICustomAxiosConfig, IRefreshtokens, ITrustedLogin } from '@/types';

export const formOptions: ICustomAxiosConfig = {
    baseURL: environment.getApigateWay(),
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
};

// 更新token
export const refreshTokens = (params?: IRefreshtokens) => Http.post('/api/v1/token/refreshtoken', params, formOptions);

// 根据gdsid获取token
export const trustedLogin = (params?: ITrustedLogin) => Http.post('/api/v1/vigo/trusted_login', params, formOptions);

// 获取用户信息
export const checkLoginTask = () => Http.post('/api/v1/token/checklogin', {});

// 文件上传
export const upload_file = (params: FormData) =>
    Http.post<string>('/base/v1/upload/upload', params, {
        baseURL: 'https://apigateway.gaodun.com/',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        timeout: 6000000,
    });

/**
 * 穿透接口 获取key
 */
export const get_bot_key = async (params: {
    /**
     * encryptedBotId
     */
    encryptedBotId: string;
}) => Http.post<string>('/gd-bot/web/bot/v1/get-key', params, { withoutToken: true });
